/**
 * Web audience symbol: the twin of `HealthAreaIcon.tsx`. Lucide user-search
 * (Recruiters), file-scan (Hiring systems) and bot (AI tools) at the 1.8
 * stroke of the design, in the current text colour. Decorative.
 */
import { Bot, FileScan, UserSearch, type LucideIcon } from 'lucide-react';
import type { CvHealthArea } from '@tabbio/types';

const AREA_ICONS: Record<CvHealthArea, LucideIcon> = {
  human: UserSearch,
  system: FileScan,
  ai_bot: Bot,
};

export function HealthAreaIcon({ area, size = 20 }: { area: CvHealthArea; size?: number }) {
  const Icon = AREA_ICONS[area];
  return <Icon size={size} strokeWidth={1.8} aria-hidden="true" focusable="false" />;
}

export default HealthAreaIcon;
